import $ from 'jquery';
import OnClick from '../accordeon/accordeon';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-category',
			dom: {
				item: '.js-category-list',
				nav: '.js-category-name',
				items: '.js-category-items',
				inner: '.js-category-checkbox'
			},
			classes: {
				footer: {
					state: {
						opened: 'category__list_state_opened'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$nav = this.$el.find(this.options.dom.nav);
		this.$items = $(this.options.dom.items);
		this.$item = $(this.options.dom.item);
		this.opened = this.options.classes.footer.state.opened;
		return this;
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$nav.on('click', OnClick.bind(this));
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/category/category.js
 **/